<template>
  <div>
    <section class="email-sent">
      <div class="container">
        <div class="email-sent__group">
          <h1 class="email-sent__title">Verifique o e-mail</h1>
          <p class="email-sent__resume">
            Enviamos um e-mail para
            {{ emailMasked(this.$route.params.userEmail) }}. Clique no link do
            e-mail para redefinir sua senha.
          </p>
          <p class="email-sent__resume">
            Caso não consiga ver o e-mail, verifique outros lugares onde ele
            possa estar, como sua pasta de lixo eletrônico, spam, social ou
            outras.
          </p>
          <p class="email-sent__resume">
            Após isso,
            <RouterLink to="/login" class="email-sent__resume-link">
              clique aqui para fazer Login.
            </RouterLink>
          </p>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { emailAsterisk } from "../utils/masks/maskEmail";
export default {
  methods: {
    emailMasked(value) {
      return emailAsterisk(value);
    }
  }
};
</script>

<style></style>
